import React from "react";

const Footer = () => {
  return (
    <footer
      className="footer"
    style={{ textAlign: "center", color: "whitesmoke" }}
    >
      <h2>
        Made By <i>Shayak Roychowdhury</i>
      </h2>
    </footer>
  );
};
export default Footer;
